import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	MenuItem,
	Typography
} from "@mui/material";
import { PaymentData } from "../../models/payment";

export interface PaymentRecordProps {
	invoiceNumber: string;
	open: boolean;
	onClose: () => void;
	onSave: (payment: PaymentData) => void;
	defaultAmount: number;
}

const PaymentRecord: React.FC<PaymentRecordProps> = ({
	invoiceNumber,
	open,
	onClose,
	onSave,
	defaultAmount
}) => {
	const [amount, setAmount] = useState<number>(defaultAmount);
	const [mode, setMode] = useState<"UPI" | "CASH" | undefined>(undefined);

	const handleSave = () => {
		if (!invoiceNumber?.trim()) {
			alert(
				"Invoice number is missing. Please generate it before recording payment."
			);
			return;
		}
		if (!mode) {
			alert("Please select a payment mode.");
			return;
		}
		const payment: PaymentData = {
			invoiceNumber: invoiceNumber.trim(),
			amount,
			mode,
			paymentDate: new Date().toISOString()
		};
		onSave(payment);
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Record Payment 💵 </DialogTitle>
			<DialogContent>
				<Typography gutterBottom>
					Invoice Number: <b>{invoiceNumber}</b>
				</Typography>
				<TextField
					label="Amount"
					type="number"
					fullWidth
					margin="normal"
					value={amount}
					onChange={(e) => setAmount(Number(e.target.value))}
					inputProps={{ min: 0, max: defaultAmount }}
				/>
				<TextField
					label="Payment Mode"
					select
					fullWidth
					margin="normal"
					value={mode}
					onChange={(e) => setMode(e.target.value as "UPI" | "CASH")}
				>
					<MenuItem value="UPI">UPI</MenuItem>
					<MenuItem value="CASH">CASH</MenuItem>
				</TextField>
			</DialogContent>
			<DialogActions
				sx={{
					flexDirection: { xs: "column", sm: "row" },
					gap: 1,
					p: { xs: 2, sm: 1 }
				}}
			>
				<Button
					onClick={onClose}
					sx={{
						width: { xs: "100%", sm: "auto" },
						m: { xs: 0, sm: 1 },
						ml: { xs: 0, sm: "auto" }
					}}
				>
					Cancel
				</Button>
				<Button
					onClick={handleSave}
					variant="contained"
					color="primary"
					sx={{
						width: { xs: "100%", sm: "auto" },
						m: { xs: 0, sm: 1 }
					}}
				>
					Save Payment
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PaymentRecord;
